import React from "react";

const Home = () => {
  return (
    <div className="home">
      <div className="text">
        <h2> Welcome to the home page </h2>
        <p>
          This is all about world's countries and their general information such
          as languages, currencies, population and so on....
        </p>
      </div>
    </div>
  );
};

export default Home;
